/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaIconTaskAlt from 'DesignSystem/Svgs/TysiaIconTaskAlt/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportFromInvisalignPracticeApp/Content/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 dangerouslyBypassFocusLock={true}
 size="small"
 paddingBottom={dtSpaceXs}
 paddingTop={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconTaskAlt
  viewPath={`${viewPath}/TysiaIconTaskAlt`}
 width={20}
 height={20}
 fill="#3F9142"
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 size="large"
 marginBottom={dtSpaceXs}
 text="Import in progress"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 color={dtColorsNeutral500}
 text="Images from Align are currently importing and will load in a bit.."
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}